<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
      <b-form @submit="onSubmit" @submit.stop.prevent>
        <validation-provider rules="email|max:50" v-slot="{ errors }">
          <b-input-group id="input-group-email">
            <b-input-group-prepend is-text>
              <b-icon icon="at"></b-icon>
            </b-input-group-prepend>
            <b-form-input id="input-email"
                          class="text-sm"
                          type="email"
                          v-model="emailToSend"
                          :placeholder="$t('forms.emailAddress')"
                          required
            ></b-form-input>
          </b-input-group>
          <span class="form-error text-sm">{{ errors[0] }}</span>
        </validation-provider>
        <div v-if="formError" class="form-error">{{$t('common.connectionError')}}</div>
        <div v-if="sentSuccess" class="text-success">{{$t('forms.sent')}}</div>
        <div class="mt-4 d-flex justify-content-end">
          <b-button class="btn btn-secondary btn-rounded text-sm px-4 d-flex align-items-center"
                    type="submit"
                    :disabled="invalid || formSending || !emailToSend">
            <span class="text-uppercase">{{$t('forms.send')}}</span>
            <b-spinner v-if="formSending" variant="white" small class="ml-2"></b-spinner>
          </b-button>
        </div>
      </b-form>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import {
  required, email, max,
} from 'vee-validate/dist/rules';
import { i18n } from 'vue-lang-router';

extend('required', {
  ...required,
  message: i18n.t('forms.thisFieldIsRequired'),
});
extend('email', {
  ...email,
  message: i18n.t('forms.emailNotValid'),
});
extend('max', {
  ...max,
  message: i18n.t('forms.maxCharacters'),
});
export default {
  props: {
    oilId: [Number, String],
  },
  data() {
    return {
      emailToSend: '',
      formSending: false,
      formError: false,
      sentSuccess: false,
    };
  },
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  methods: {
    onSubmit() {
      this.formSending = true;
      this.formError = false;
      this.sentSuccess = false;
      this.$store.dispatch('oilGasFinder/SEND_EMAIL', { oilId: this.oilId, email: this.emailToSend }).then(() => {
        this.formSending = false;
        this.sentSuccess = true;
        this.emailToSend = '';
      }).catch(() => {
        this.formSending = false;
        this.formError = true;
      });
    },
  },
};
</script>
<style lang="scss">
.form-error {
  color: red;
}
</style>
